var _rect, _text, _text2, _text3, _text4, _text5, _text6, _line, _clipPath, _g, _rect2, _text7, _text8, _text9, _text10, _text11, _text12, _text13, _text14, _line2, _polygon, _text15, _text16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCase3Fig4MinedBacklogComposition(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 600",
    fontFamily: "Geist, 'Segoe UI', -apple-system, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1200,
    height: 600,
    fill: "#FFFDF7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 52,
    fontSize: 22,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "The corrective mine's output")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 76,
    fontSize: 14,
    fill: "#4A5F56"
  }, "3,078 units from 49 books, split across the content-type ladder.")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 152,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 34,
    fontWeight: 700,
    fill: "#1A2F2A"
  }, "3,078")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 174,
    fontSize: 12,
    fill: "#6B7F74"
  }, "units mined into the backlog")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 146,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#6B7F74"
  }, "49 BOOKS, 11 WAVES")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 700,
    y: 172,
    fontSize: 12.5,
    fontWeight: 600,
    fill: "#16A34A"
  }, "the tier the previous pipeline captured at zero")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1030,
    y1: 180,
    x2: 1022,
    y2: 204,
    stroke: "#16A34A",
    strokeWidth: 1.5,
    strokeDasharray: "3 3"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "barclip"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 210,
    width: 1104,
    height: 110,
    rx: 12
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#barclip)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 210,
    width: 613,
    height: 110,
    fill: "#1A2F2A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 661,
    y: 210,
    width: 115.1,
    height: 110,
    fill: "#4A5F56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 776.1,
    y: 210,
    width: 116.6,
    height: 110,
    fill: "#6B7F74"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 892.7,
    y: 210,
    width: 259.3,
    height: 110,
    fill: "#EAF6EE"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 661,
    y1: 210,
    x2: 661,
    y2: 320,
    stroke: "#FFFDF7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 776.1,
    y1: 210,
    x2: 776.1,
    y2: 320,
    stroke: "#FFFDF7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 892.7,
    y1: 210,
    x2: 892.7,
    y2: 320,
    stroke: "#FFFDF7",
    strokeWidth: 2
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 892.7,
    y: 211.5,
    width: 258,
    height: 107,
    rx: 10,
    fill: "none",
    stroke: "#16A34A",
    strokeWidth: 2.5
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 354.5,
    y: 254,
    fontSize: 13,
    fontWeight: 600,
    fill: "#FFFFFF",
    textAnchor: "middle"
  }, "Atoms")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 354.5,
    y: 288,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 24,
    fontWeight: 700,
    fill: "#FFFFFF",
    textAnchor: "middle"
  }, "1,709")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 718.5,
    y: 254,
    fontSize: 12.5,
    fontWeight: 600,
    fill: "#FFFFFF",
    textAnchor: "middle"
  }, "Recipes")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 718.5,
    y: 286,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 20,
    fontWeight: 700,
    fill: "#FFFFFF",
    textAnchor: "middle"
  }, "321")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 834.4,
    y: 254,
    fontSize: 12.5,
    fontWeight: 600,
    fill: "#FFFFFF",
    textAnchor: "middle"
  }, "Playbooks")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 834.4,
    y: 286,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 20,
    fontWeight: 700,
    fill: "#FFFFFF",
    textAnchor: "middle"
  }, "325")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 1022.3,
    y: 254,
    fontSize: 13,
    fontWeight: 600,
    fill: "#16A34A",
    textAnchor: "middle"
  }, "Frameworks")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 1022.3,
    y: 290,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 26,
    fontWeight: 700,
    fill: "#16A34A",
    textAnchor: "middle"
  }, "723")), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 356,
    x2: 1136,
    y2: 356,
    stroke: "#D4DDD6",
    strokeWidth: 1.5
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "1136,351 1148,356 1136,361",
    fill: "#D4DDD6"
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 382,
    fontSize: 11.5,
    fill: "#6B7F74"
  }, "the content-type ladder climbs left to right, from single plays up to full frameworks")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 556,
    fontSize: 11.5,
    fill: "#6B7F74"
  }, "tier names are the mining run's June taxonomy; the catalog vocabulary later renamed atoms (today's plays) and retired recipes")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase3Fig4MinedBacklogComposition);
export default __webpack_public_path__ + "static/media/case3-fig4-mined-backlog-composition.114679dc1e5110d659c5a859d7631256.svg";
export { ForwardRef as ReactComponent };